import React from 'react'
import Button from '../../Component/Button/Button'
import { useForm } from 'react-hook-form'
import ULogin from './Login.module.css'
import { useHistory } from "react-router";
import { errorToast} from '../../Toast/Toast'
import BurgerMenuTitle from '../../Component/BurgerMenuTitle/BurgerMenuTitle'

const Login=()=>{
    const history=useHistory()
    const{register , handleSubmit , formState : {errors}}=useForm() 

    const onSubmitHandler=(data)=>{
        if(data.phone==='') errorToast("شماره تماس وارد نشده")
        else{
            history.push('./confirm',data.phone)
        }
    }
    return(
        <div>
            <BurgerMenuTitle/>
            <div className={ULogin.Center}>
                <section className={ULogin.InnerPart}>
                    <div className={ULogin.PicHolder}>
                        <img src="/Assets/Images/UserLogin/barestLogo.svg" alt="برست"/>
                    </div>
                    <form onSubmit={handleSubmit(onSubmitHandler)} className={ULogin.btnPart}>
                        <input 
                        {...register("phone",{required:true})} 
                        className={errors.phone ? ULogin.isValid :ULogin.telInput } 
                        placeholder="شماره تلفن خود را وارد کنید"  
                        maxLength="11"
                        />
                        <Button  ClassBtn={"confrimBtn"} Value="ارسال کد تایید"/>
                    </form>
                </section>
            </div>
        </div>
           
    )
}
export default Login;